import { Checkbox, Box, Modal, Button, Grid, Paper, FormLabel, TextField, FormHelperText, FormControlLabel, FormControl, RadioGroup, Radio, Autocomplete } from '@mui/material'
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CancelIcon from '@mui/icons-material/Cancel';
import { styled } from '@mui/material/styles';
import axios from '../../../../services/utility/axios-retro-discount-schemes';
import PageLoader from '../../../../components/shared/PageLoader';
import { setRetroState, getIsError } from '../../../../store/slices/retrodiscountschemes';
import { handleModalState } from '../../../../store/slices/modals';
import product_axios from "../../../../services/utility/axios";
import axios_categories from '../../../../services/utility/axios-categories';

const Item = styled(Paper)(({ theme }) => ({
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    boxShadow: "none"
}));

function AddEditCategories({ onShow, size = '', onHide, onSubmitDate }) {
    const [state, setState] = useState({
        dueDate: '',
        payDateDescription: '',
        onTrade: false,
        discountabl_bopa: false,
        defaultmode: false,
        pageLoader: false,
        formValid: true
    })

    const [included, setIncluded] = useState(true);

    const { retro_fields } = useSelector((state) => {
        return {
            retro_fields: state.retrodiscountscheme,
        }
    });
    const dispatch = useDispatch();

    const [categories, setCategories] = useState({
        categories_options: [],
        categories_selected: retro_fields.hasEditCategories ? retro_fields.hasEditCategories.category : null
    })
    const [isError, setIsError] = useState({
        categories_selected: false
    })

    const handleChange = (event) => {
        if(retro_fields.hasEditCategories) {
            setState({ ...state, defaultmode: true })
        } 
        setIncluded(event.target.checked);
    };

    useEffect(() => {
        const fetchMyAPI = async () => {
            if (categories.categories_options.length === 0) {
                axios_categories.get('/v2/categories/parent-dropdown?level=0')
                    .then(function (response) {
                        // handle success
                        const { status, data } = response;
                        if (data) {
                            const unique = data.filter((value, index, self) => self.findIndex((m) => m.name === value.name) === index);
                            setCategories({ ...categories, categories_options: unique })
                        }
                    })
                    .catch(function (error) {
                        // handle error
                        console.log(error)
                    });
            }
        }
        fetchMyAPI();
    }, [])


    const [open, setOpen] = useState(onShow);

    const handleClose = () => {
        //setState({ ...state, defaultmode: false })
        dispatch(handleModalState({
            key: 'addEditCategoriesModal',
            value: false
        }))
        dispatch(setRetroState({
            key: 'hasEditCategories',
            value: null
        }))
        dispatch(getIsError({ key: 'categories_selected', value: false }))
    };

    const handleSelf = () => {
        handleClose()
    }

    useEffect(() => {
        if (categories.categories_selected === null || categories.categories_selected === "") {
            setState({ ...state, formValid: true, defaultmode: false})
        } else {
            setState({ ...state, formValid: false, defaultmode: true})
        }
    }, [categories.categories_selected])

    useEffect(() => {
        const {
            categories_selected
        } = retro_fields.isError
        if (!categories_selected) {
            setState({ ...state, formValid: false })
        } else {
            setState({ ...state, formValid: true })
        }
    }, [retro_fields.isError])

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (categories.categories_selected === null && isError.categories_selected === false) {
            setIsError({ ...isError, categories_selected: true })
        } else {
            addPayDate()

        }

    }
    const addPayDate = async () => {
        let payload = null;
        const id = (retro_fields.hasEditData) ? (retro_fields.hasEditData.id) : retro_fields.editTabData.id
        if (id && retro_fields.hasEditCategories === null) {
            payload = {
                "category": categories.categories_selected ? {
                    id: categories.categories_selected ? categories.categories_selected.id : ""
                } : "",
                included,
                "retroDiscountScheme": id
            }
        } else if (retro_fields.hasEditCategories !== null) {
            payload = {
                "id": retro_fields.hasEditCategories.id,
                "category": categories.categories_selected ? {
                    id: categories.categories_selected ? categories.categories_selected.id : ""
                } : "",
                included,
                "retroDiscountScheme": retro_fields.hasEditCategories.retroDiscountScheme
            }
        }

        try {
            setState({ ...state, pageLoader: true })
            const url = ((retro_fields.hasEditData !== null || retro_fields.editTabData !== null) && retro_fields.hasEditCategories === null) ? 'addcategories' : 'updatecategories';
            const { data } = url === 'addcategories' ? await axios.post(`/retrodiscount/${id}/${url}`, payload) : await axios.put(`/retrodiscount/${id}/${url}`, payload)

            if (data) {
                onSubmitDate({ text: data.message, type: "success" })
                setState({ ...state, pageLoader: false })
                handleClose()
            }

        } catch (error) {
            const { response: { data, status } } = error;
            if (!data) {
                onSubmitDate({ text: error.message, type: "error" })
            } else {
                onSubmitDate({ text: data.message, type: "error" })
            }
            setState({ ...state, pageLoader: false })
            handleClose()
        }
    }

    useEffect(() => {
        if (retro_fields.hasEditCategories !== null) {
            setCategories({ ...categories, categories_selected: retro_fields.hasEditCategories.categories })
            setIncluded(retro_fields.hasEditCategories.included)
        }
    }, [])


    useEffect(() => {
        const inputNumber = document.querySelectorAll('.inputNumber');
        inputNumber.forEach(el => el.addEventListener('keypress', evt => {
            if (evt.which === 8) {
                return;
            }
            if (evt.which < 42 || evt.which > 60) {
                evt.preventDefault();
            }
        }));
    }, []);

    return (
        <>


            <Modal
                open={open}
                aria-labelledby="add-edit-price-title"
                aria-describedby="add-edit-price-description"
                keepMounted
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose();
                    }
                }}
            >
                <form onSubmit={(e) => handleSubmit(e)}>
                    <Box component="div" className="overlay" id="addEditModal">
                        {state.pageLoader && <PageLoader />}
                        <div className={`overlay-box ${size ? size : ''}`}>
                            <div className="content">
                                <div className="overlayBody">
                                    <div className="overlay-header text-center"> Categories
                                        <CancelIcon className="closeBtn" onClick={handleClose} />
                                    </div>
                                    <div className="overlay-content">
                                        <Grid item xs={12} md={12}>
                                            <Item sx={{ marginBottom: 2.5 }}>
                                                <Grid container alignItems="center">
                                                    <Grid item xs={12} md={4.5} sx={{ textAlign: 'right' }}>
                                                        <Item>
                                                            <FormLabel htmlFor="type" className="fontSemiBold mandatory">Category</FormLabel>
                                                        </Item>
                                                    </Grid>
                                                    <Grid item xs={12} md={7.5}>
                                                        <Item>
                                                            <Autocomplete
                                                                defaultValue={categories.categories_selected ? categories.categories_selected : null}
                                                                id="categories_search"
                                                                options={categories.categories_options}
                                                                getOptionLabel={(option) => option.name || ""}
                                                                componentsProps={{
                                                                    paper: {
                                                                        sx: {
                                                                            fontSize: '0.85rem'
                                                                        }
                                                                    }
                                                                }}
                                                                onChange={(event, newValue) => {
                                                                    (isError['categories_selected'] === null || isError['categories_selected'] === "") ? setIsError({ ...isError, categories_selected: true }) : setIsError({ ...isError, categories_selected: false })
                                                                    if (event.target.value !== undefined) {
                                                                        setState({ ...state, defaultmode: true })
                                                                        setCategories({ ...categories, categories_selected: newValue })
                                                                        dispatch(getIsError({ key: 'categories_selected', value: false }))
                                                                    } else {
                                                                        dispatch(getIsError({ key: 'categories_selected', value: true }))
                                                                    }
                                                                }}
                                                                renderInput={(params) =>
                                                                    <FormControl size={'small'} fullWidth>
                                                                        <div className="input-group">
                                                                            <TextField {...params}
                                                                                size="small"
                                                                                id="categories"
                                                                                aria-describedby="categories-error"
                                                                                error={isError.categories_selected}
                                                                            />
                                                                            {retro_fields.isError.categories_selected && (<FormHelperText className='errorHelperTxt' id="categories-error">
                                                                                Please select category
                                                                            </FormHelperText>)}
                                                                        </div>
                                                                    </FormControl>
                                                                }
                                                            />
                                                        </Item>
                                                    </Grid>
                                                </Grid>
                                            </Item>
                                            <Item sx={{ marginBottom: 2.5 }}>
                                                <Grid container alignItems="center">
                                                    <Grid item xs={12} md={4.5} sx={{ textAlign: 'right' }}>
                                                        <Item>
                                                            <FormLabel htmlFor="included" className="fontSemiBold">Include/Exclude</FormLabel>
                                                        </Item>
                                                    </Grid>
                                                    <Grid item xs={12} md={7.5}>
                                                        <Item>
                                                            <div className="input-group">
                                                                <Checkbox
                                                                    checked={included}
                                                                    onChange={handleChange}
                                                                    inputProps={{ 'aria-label': 'controlled' }}
                                                                />
                                                            </div>
                                                        </Item>
                                                    </Grid>
                                                </Grid>
                                            </Item>
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <Item sx={{ marginBottom: 2.5 }}>
                                                <Grid container alignItems="center">
                                                    <Grid item xs={12} md={4.5} sx={{ textAlign: 'right' }}>
                                                        <Item>
                                                            &nbsp;
                                                        </Item>
                                                    </Grid>
                                                    <Grid item xs={12} md={7.5}>
                                                        <Item>
                                                            <Grid container direction="row" alignItems="center">
                                                                <Button 
                                                                    variant="contained" 
                                                                    type="submit" 
                                                                    sx={{ marginRight: '15px' }} 
                                                                    //disabled={((retro_fields.hasEditCategories && retro_fields.hasEditCategories.confirmed === true) ? true : false) || state.defaultmode === false}
                                                                    // eslint-disable-next-line max-len
                                                                    disabled={((retro_fields.hasEditData !== null || retro_fields.editTabData !== null) && retro_fields.hasEditCategories) ? retro_fields.isError.categories_selected : (state.formValid || state.defaultmode === false)}
                                                                >Save</Button>
                                                                <Button variant="outlined" onClick={handleSelf}>Cancel</Button>
                                                            </Grid>
                                                        </Item>
                                                    </Grid>
                                                </Grid>
                                            </Item>
                                        </Grid>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Box>
                </form>

            </Modal>
        </>
    );
}

export default AddEditCategories;